






































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import { Button, Slider } from 'element-ui';
import {
  QuoteDetailsFields,
  QuoteSectionFields,
  fetchQuotes_inquiries_quotes
} from '@/types/graphql/schemaTypes';
import { InstantQuoteItem } from '@/types/types';
import { i18n } from '@/plugins/i18n';
// SVGS
import air from '@/components/svgs/air.vue';
import container from '@/components/svgs/container.vue';
import ship from '@/components/svgs/ship.vue';
import truck from '@/components/svgs/truck.vue';

@Component({
  components: {
    air,
    container,
    ship,
    truck,
    'el-button': Button,
    'el-slider': Slider
  }
})
export default class QuoteItem extends Vue {
  @Prop({ required: true }) public quote!: fetchQuotes_inquiries_quotes;
  @Prop({ type: String, required: true }) public type!: string;
  @Prop({ type: Boolean, default: false }) public applied!: boolean;
  @Prop({ type: Boolean, default: false }) public selected!: boolean;

  private margin = 0;
  private max = 0;
  private orderedDetails: {
    selected: boolean;
    type: string;
    total: number;
    totalCost?: number;
  }[] = [];

  private selectedSections: string[] = [];
  private total = 0;
  private totalCost = 0;
  // slider selcted range
  private value: number[] = [0, this.max];

  private getIcon(segmentType: string) {
    switch (segmentType) {
      case 'arrivalDrayage':
      case 'departureDrayage':
        return 'container';
      case 'arrivalTrucking':
      case 'departureTrucking':
        return 'truck';
      case 'transport':
        return this.quote.inquiry.transportationType === 'sea' ? 'ship' : 'air';
      default:
        break;
    }
  }

  private applyQuote() {
    this.$store.dispatch('Inquiry/selectQuote', {
      quoteId: this.quote.id,
      selectedSections: this.selectedSections
    }).then(() => {
      this.$store.dispatch('Alert/addAlert', {
        type: 'success',
        message: i18n.t('inquiry.quote.applied'),
        time: 5000
      }).then(() => {
        this.$router.push({
          name: 'inquiryQuote',
          params: { id: this.quote.inquiry.id || '' }
        });
      });
    });
  }

  private calculateTotals() {
    // clear values
    this.total = 0;
    this.margin = 0;
    this.totalCost = 0;

    // loop from min to max selected sections
    for (let index = this.value[0]; index < this.value[1]; index += 1) {
      this.total += this.orderedDetails[index].total;
      this.totalCost += this.orderedDetails[index].totalCost || 0;
    }
    // add extra cost if any
    this.total += this.quote.details.extra.total || 0;
    this.totalCost += this.quote.details.extra.totalCost || 0;
    // calculate margin
    this.margin = Math.round(((this.total - this.totalCost) / this.total) * 10000) / 100;
  }

  // section are fetched in camel but yama are in snake
  private camelToSnake(string: string) {
    return string.replace(/[\w]([A-Z])/g, (m) => {
      return m[0] + '_' + m[1];
    }).toLowerCase();
  }

  // rebind min and max selected range
  private findMinMax() {
    // create an array of indexes with all index of selected sections
    const indexes: number[] = [];
    this.orderedDetails.every((detail, index) => {
      if (detail.selected) {
        indexes.push(index);
      } else if (indexes.length) {
        return false;
      }
      return true;
    });

    // find min and max index (max have +1 to fit set in slider)
    this.value = [Math.min(...indexes) || 0, Math.max(...indexes) + 1];
  }

  private setSelectedSection() {
    // clear selectedSection
    this.selectedSections = [];
    // // add selected section
    for (let index = this.value[0]; index < this.value[1]; index += 1) {
      this.selectedSections.push(this.camelToSnake(this.orderedDetails[index].type));
    }
    // re calculates totals
    this.calculateTotals();
  }

  @Watch('quote', { immediate: true })
  private setData() {
    // re init values
    this.orderedDetails = [];
    this.max = 0;

    // build sorted array for display purpose
    if (this.quote) {
      type DetailsProps = keyof QuoteDetailsFields;
      const orderedSections: DetailsProps[] = [
        'departureTrucking',
        'departureDrayage',
        'transport',
        'arrivalDrayage',
        'arrivalTrucking'
      ];

      // looping through sections
      for (const section of orderedSections) {
        // if exists push to orderedDetails
        this.orderedDetails.push({
          selected: this.quote.details[section].selected || false,
          type: section,
          total: this.quote.details[section].total || 0,
          totalCost: this.quote.details[section].totalCost || 0
        });

        if (this.quote.details[section].total !== 0) {
          this.max += 1;
        } else {
          // pop section that is not relevant
          this.orderedDetails.pop();
        }
      }
      // set min and max value of slider
      this.value = [0, this.max];

      this.findMinMax();
      // calculates totals
      this.calculateTotals();
    }
  }
}
